import React, { Component } from 'react';
import './App.css';
import Nav from './modals/Nav';

class App extends Component {

    constructor() {
        super();
        this.state={
            showScrollToTop: false,
            pageHeight: window.innerHeight,
            redirected: false
        }
    }

    _handleResize = () => {
        this.setState({
            pageHeight: window.innerHeight
        })
    }

    componentDidMount() {
        window.addEventListener('resize', this._handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._handleResize)
    }

    scrollToTop = () => {
        var scrollMode = 2; // 1 or 2

        var step; var smoothScroll;

        var scrollPage = document.querySelector('#scroll-page');
        var scrollTop = scrollPage.scrollTop;

        switch (scrollMode) {
            case 1 :    /* OPTION 1 : Fixed time scrolling */
                // Smoothness
                var nbSteps = 50;
                // Duration
                var transitionTime = 300;
                step = scrollTop/nbSteps;
                var stepCount=0;
                smoothScroll = setInterval( () => {
                    scrollPage.scrollTop = document.querySelector('#scroll-page').scrollTop-step;
                    stepCount++;
                    if (stepCount>=nbSteps) {
                        window.clearInterval(smoothScroll);
                    }
                }, transitionTime/nbSteps);
                break;

            case 2 :    /* OPTION 2 : Fixed speed scrolling */
                // Smoothness
                step = 40;
                // Speed
                var stepPerSecond = 800;
                smoothScroll = setInterval( () => {
                    document.querySelector('#scroll-page').scrollTop = document.querySelector('#scroll-page').scrollTop-step;
                    if (document.querySelector('#scroll-page').scrollTop<=0) {
                        window.clearInterval(smoothScroll);
                    }
                }, 1000/stepPerSecond);
                break;

            default:
        }

    }

    _handleScroll = () => {
        if (window.location.hash === '#/checklist') {
            if (!this.state.showScrollToTop) {
                this.setState({
                    showScrollToTop: true
                })
            }
            const scrollPage = document.getElementById('scroll-page');
            var scrollTop = scrollPage.scrollTop;

            if (scrollTop > 0 && !this.state.showScrollToTop) {
                this.setState({
                    showScrollToTop: true
                })
            } else {
                if (scrollTop === 0 && this.state.showScrollToTop) {
                    this.setState({
                        showScrollToTop: false
                    })
                }
            }
        } else {
            this.setState({
                showScrollToTop: false
            })
        }
    }

    render() {
        return (
            <div className="App" onScroll={this._handleScroll} >
                {/* <div className='overlay'></div> */}
                <img src='images/back_to_top.png' style={{display: this.state.showScrollToTop ? 'block' : 'none' }} className='scroll-to-top' onClick={this.scrollToTop} alt='Scroll to top button'/>
                <Nav/>
                <div id='scroll-page' className='scrollable-page' style={{height: (this.state.pageHeight-80-40)}} onScroll={this._handleScroll} >
                    {React.cloneElement(this.props.children, {
                        rerender: ()=>this._handleScroll()
                    } )}
                </div>
                <div className='bottom-banner'>
                    <div className='FD-footer'>
                        <a href="https://www.northone.io/?utm_source=checklist"><img src='images/white logo.png' alt='NorthOne Logo'/></a>
                        <div className='footer-subtitle'> Your business banking, built for a mobile world </div>
                    </div>
                    <a href='/tnc/termsandconditions.html' className="terms-and-conditions">
                        Terms and Conditions
                    </a>
                </div>
            </div>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// src/components/App.js